import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaSolicitante} from "../models/lista-solicitante";
import {ListaPessoa} from "../models/lista-pessoa";
import {DetalhesAtendimento} from "../models/detalhes-atendimento";
import {PessoaDetalhes} from "../models/pessoa-detalhes";
import {NovaPessoa} from "../models/nova-pessoa";

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`ClienteService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaPessoa> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPessoa>>(`${this.baseUrl}/Cliente`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarListaAtivos(): Observable<BaseResponse<ListaPessoa> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPessoa>>(`${this.baseUrl}/Cliente/Ativos`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarPorId(id: number): Observable<BaseResponse<PessoaDetalhes> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<PessoaDetalhes>>(`${this.baseUrl}/Cliente/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorId')));
  }

  alterar(request: PessoaDetalhes): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Cliente`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`alterar`)));
  }

  adicionar(request: NovaPessoa): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Cliente`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`adicionar`)));
  }

  desativar(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
          .delete<BaseResponse<boolean>>(`${this.baseUrl}/Cliente/${id}`)
          .pipe(catchError(this.handlerErro<BaseResponse<any>>(`desativar`)));
  }
}
